namespace TabAurous.Production {
    export interface MFGInspectionValuesForm {
        TransItemId: Serenity.StringEditor;
        Parameter: Serenity.StringEditor;
        ExpectedValue: Serenity.StringEditor;
        InspectedValue: Serenity.StringEditor;
        Status: Serenity.BooleanEditor;
        Min: Serenity.StringEditor;
        Max: Serenity.StringEditor;
        Remark: Serenity.StringEditor;
    }

    export class MFGInspectionValuesForm extends Serenity.PrefixedContext {
        static formKey = 'Production.MFGInspectionValues';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!MFGInspectionValuesForm.init)  {
                MFGInspectionValuesForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.BooleanEditor;

                Q.initFormType(MFGInspectionValuesForm, [
                    'TransItemId', w0,
                    'Parameter', w0,
                    'ExpectedValue', w0,
                    'InspectedValue', w0,
                    'Status', w1,
                    'Min', w0,
                    'Max', w0,
                    'Remark', w0
                ]);
            }
        }
    }
}
